import React from 'react';
import { Route } from 'react-router-dom';

import IntegrationListing from './pages/IntegrationListing';

export default () => (
    <Route path="/" component={IntegrationListing} />
);
